import { render, staticRenderFns } from "./IsverenList.vue?vue&type=template&id=7722bac5"
import script from "./IsverenList.vue?vue&type=script&lang=ts"
export * from "./IsverenList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports